import Common from "../modules/common";
import InfoCardSlider from "../blocks/info-card-slider";

const TemplateEvents = {
  init() {
    new InfoCardSlider(".info-card-slider");
    this.events();
  },

  events() {
    let throttle = null;
    $('.service-filter select').on('change', function () {
      clearTimeout(throttle);
      throttle = setTimeout(function () {
        TemplateEvents.handleFilters();
      }, 500);
    });

    $('body').on('click', '.page-numbers', function (e) {
      e.preventDefault();
      const pageEl = $(this);
      let page = parseInt($('#page').val());

      if (pageEl.hasClass('next')) {
        page = page + 1;
      } else if (pageEl.hasClass('prev')) {
        page = page - 1;
      } else {
        page = pageEl.text();
      }

      $('html,body').animate({
        scrollTop: $('.portfolio-list').offset().top - 100
      })

      TemplateEvents.handleFilters(page);
    });

    window.onpopstate = function (event) {
      TemplateEvents.handleState(event.state);
    }
  },

  /**
   * Create url with filters
   */
  handleFilters(cpage = 1) {
    $('.portfolio-list .loader').addClass('loading');
    const filters = {
      cpage,
    };

    $('#page').val(cpage);

    $('.service-filter select').each(function () {
      const select = $(this);
      const name = select.attr('name');

      if ( select.val() ) {
        filters[name] = select.val();
      }
    });

    const searchParams = new URLSearchParams(filters);
    const url = window.location.pathname + '?' + searchParams.toString();

    history.pushState(filters, '', url);
    TemplateEvents.loadPortfolios(filters);
  },

  handleState(state) {
    $('.tours-list .loader').addClass('loading');

    if (!state) {
      state = {
        duration: '',
        season: '',
        page: 1,
      }
    }

    Object.keys(state).forEach(function (key) {
      $(`.service-filter [name=${key}]`).val(state[key]);
    });

    TemplateEvents.loadPortfolios(state);
  },

  /**
   * Get items from admin
   */
  loadPortfolios(filters) {
    // Ajax
    $.ajax({
      url: ajaxurl,
      type: 'POST',
      data: {
        action: 'filtered_all_events',
        duration: filters.duration,
        season: filters.season,
        page: filters.cpage,
      },
    }).done(function (response) {
      $('#tours').html(response.items);
      $('#pager').html(response.pager);
      Common.lazyload.update();
    }).always(function () {
      $('.tours-list .loader').removeClass('loading');
    });
  }
};

export default TemplateEvents;
